/**
 * @generated SignedSource<<ba47949b64d156d377c780186a6599db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "VibeFollowers",
    "kind": "LinkedField",
    "name": "unfollowUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "follower",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "following",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followersCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postMenuUnfollowUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postMenuUnfollowUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a67566a29ec639faddc199ccf805e357",
    "id": null,
    "metadata": {},
    "name": "postMenuUnfollowUserMutation",
    "operationKind": "mutation",
    "text": "mutation postMenuUnfollowUserMutation(\n  $userId: String!\n) {\n  unfollowUser(userId: $userId) {\n    id\n    follower {\n      id\n      followingCount\n    }\n    following {\n      id\n      followersCount\n      followingUser\n    }\n  }\n}\n"
  }
};
})();

node.hash = "8e4ac2af919a701bf0a0ca13a09c9bc7";

module.exports = node;
